var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_213_36161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.45312 9.4604V7.54634H4.53906C4.237 7.54634 3.99219 7.30153 3.99219 6.99947C3.99219 6.69751 4.237 6.45259 4.53906 6.45259H6.45312V4.53853C6.45312 4.23657 6.69794 3.99165 7 3.99165C7.30206 3.99165 7.54688 4.23657 7.54688 4.53853V6.45259H9.46094C9.763 6.45259 10.0078 6.69751 10.0078 6.99947C10.0078 7.30153 9.763 7.54634 9.46094 7.54634H7.54688V9.4604C7.54688 9.76247 7.30206 10.0073 7 10.0073C6.69794 10.0073 6.45312 9.76247 6.45312 9.4604ZM11.9498 2.05025C10.6276 0.728134 8.86974 0 7 0C5.13026 0 3.37236 0.728134 2.05025 2.05025C0.728134 3.37236 0 5.13026 0 7C0 8.86974 0.728134 10.6276 2.05025 11.9498C3.37236 13.2719 5.13026 14 7 14C8.28003 14 9.5325 13.6512 10.622 12.9912C10.8804 12.8347 10.9629 12.4984 10.8064 12.2402C10.65 11.9818 10.3136 11.8992 10.0553 12.0557C9.13676 12.6121 8.08018 12.9062 7 12.9062C3.74332 12.9062 1.09375 10.2567 1.09375 7C1.09375 3.74332 3.74332 1.09375 7 1.09375C10.2567 1.09375 12.9062 3.74332 12.9062 7C12.9062 8.16457 12.56 9.29805 11.9048 10.2782C11.7369 10.5292 11.8044 10.8688 12.0555 11.0367C12.3065 11.2045 12.6462 11.137 12.8141 10.886C13.5898 9.72551 14 8.38171 14 7C14 5.13026 13.2719 3.37236 11.9498 2.05025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_213_36161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.f46185a1eb3f42addc41c4f8594ff928.svg";
export { ForwardRef as ReactComponent };